<!-- 数据统计 -->
<template>
  <div class="data-analysis">
    <div class="numBer">
      <div v-for="(item,index) in statisticsData" :key="index" class="numBer-item">
        <div class="icon-left"><img :src="item.img" alt=""></div>
        <div class="text-right">
          <div class="name">{{item.name}}</div>
          <div class="total">{{million(item.total)}}</div>
          <div class="todayNum">+{{million(item.todayNum)}} <span>今日</span></div>
        </div>
      </div>
    </div>
    <ProgramTotal ref="weekAnalysisBox"> </ProgramTotal>
    <ProgramTime ref="sevenTopBox" ></ProgramTime>
    <Classify ref="putCategoryProgramBox"></Classify>
  </div>
</template>
<script>
import { getCountProgram } from '@/resource/api/dataAnalysis'
import ProgramTime from './programTime.vue'
import Classify from './classify.vue'
import ProgramTotal from './programTotal.vue'
export default {
  components: {
    ProgramTime,
    Classify,
    ProgramTotal
  },
  data () {
    return {
      searchParams: {
        createBy: this.$store.state.router.createBySuffix
      },
      statisticsData: [
        {
          img: require('../../../../assets/icon_5.png'),
          name: '节目集条数',
          total: 0,
          todayNum: 0
        },
        {
          img: require('../../../../assets/icon_6.png'),
          name: '节目条数',
          total: 0,
          todayNum: 0
        },
        {
          img: require('../../../../assets/icon_7.png'),
          name: '审核通过条数',
          total: 0,
          todayNum: 0
        }, {
          img: require('../../../../assets/icon_8.png'),
          name: '节目时长（h）',
          total: 0,
          todayNum: 0
        }
      ]
    }
  },
  mounted () {
    this.pageInit() // 初始化数据
  },
  methods: {
    pageInit () {
      this.getCountProgramData()
    },
    getCountProgramData () {
      getCountProgram({ createBy: this.$store.state.router.createBySuffix }).then((res) => {
        this.statisticsData[0].total = res.result.programTotalSetNum
        this.statisticsData[0].todayNum = res.result.programSetNum
        this.statisticsData[1].total = res.result.programTotalNum
        this.statisticsData[1].todayNum = res.result.programNum
        this.statisticsData[2].total = res.result.auditTotalNum
        this.statisticsData[2].todayNum = res.result.auditNum
        this.statisticsData[3].total = res.result.durationTotalSum
        this.statisticsData[3].todayNum = res.result.durationSum
      })
    },
    // 过万处理
    million (value) {
      let num
      if (value > 9999) { // 大于9999显示x.xx万
        num = (Math.floor(value / 1000) / 10) + 'W'
      } else if (value < 9999 && value >= 0) {
        num = value
      }
      return num
    }
  }
}
</script>
<style lang="less" scoped>
  @import "../../../../assets/css/dataAnalysis.less";
</style>
